import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const FloatingFormContext = /*#__PURE__*/createContext(undefined);
export const FloatingFormProvider = ({
  formStylesOverrides,
  children
}) => {
  const value = useMemo(() => ({
    formStylesOverrides
  }), [formStylesOverrides]);
  return /*#__PURE__*/_jsx(FloatingFormContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `FloatingForm` component.
 * Note: The context is only available when the `FloatingForm` component is rendered as an ancestor.
 * @returns FloatingFormContext - The context for the `FloatingForm` component.
 * @returns FloatingFormContext.formStylesOverrides - Style overrides to be applied to the `Popover` component.
 */
export const useFloatingFormContext = () => {
  const floatingFormContext = useContext(FloatingFormContext);
  return floatingFormContext;
};